<div *ngIf="message"> 
    <div class="p-grid">
        <div class="p-col-4 p-lg-2 p-md-2 p-sm-2" *ngIf="canDeleteMessage">
            <button pButton type="submit" class="fullwidthbtn" label="REMOVE MESSAGE" (click)="removeMessage()"></button>
        </div>
    </div>
 
    <div class="card">
        <div class="message-header">{{message.HeadLine}}</div>
        <p-divider></p-divider>
        <div></div>
        <div class="p-grid">
            <div class="p-col-12 p-lg-6 p-md-6">
                <strong>Presented By: </strong>{{message.ContactName}}               
            </div>
            <div class="p-col-12 p-lg-6 p-md-6"><strong>Deal Type: </strong>{{message.DealTypesName}}</div>
            <div class="p-col-12 p-lg-6 p-md-6"><strong>Phone Number: {{formatPhoneNumber(message.ContactPhone)}}</strong></div>
            <div class="p-col-12 p-lg-6 p-md-6"><strong>Property: </strong>{{message.PropertyTypesName}}</div>
            <div class="p-col-12 p-lg-6 p-md-6">
                <strong>Email: </strong>
                <p-button label="{{message.ContactEmail}}" styleClass="p-button-link" (click)="NavMailto()"></p-button>
                <!--<p-button label="Email" styleClass="inlinebtn" (click)="NavMailto()"></p-button>-->
            </div>
            <div class="p-col-12 p-lg-6 p-md-6"><strong>Location: </strong>{{getLocation()}}</div>
            <div class="p-col-12 p-lg-6 p-md-6">
                <strong>VCard: </strong>
                <input class="imageButton" type="image" src="assets/layout/images/naiimages/card-address.png" (click)="downloadVCard()">
            </div>
            <div class="p-col-12 p-lg-6 p-md-6"><strong>Admin Email: </strong>{{message.AdminEmail}}</div>
            <div class="p-col-12 p-lg-12 p-md-12" innerHTML="{{message.BroadcastBody}}"></div>
            <div class="p-col-12 p-lg-12 p-md-12">
                <strong>Attachments:</strong>
                <ul>
                    <li *ngFor="let doc of message.Documents">
                        <a class="hyperLink" (click)="OpenUrl(doc)">{{doc.Title}}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
